import React, { Component } from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
const localizer = momentLocalizer(moment) // or globalizeLocalizer

// [
//   {
//     'title': 'My event',
//     'allDay': false,
//     'start': new Date("2020-07-02T06:59:46.000Z"), // 10.00 AM
//     'end': new Date("2020-07-02T06:59:46.000Z"), // 2.00 PM 
//   },
//   {
//     'title': 'My event',
//     'allDay': false,
//     'start': new Date("2020-07-05T06:59:46.000Z"), // 10.00 AM
//     'end': new Date("2020-07-05T06:59:46.000Z"), // 2.00 PM 
//   }
// ]

let formats = {
  dayHeaderFormat: (date, culture, localizer) =>
    localizer.format(date, 'Do MMMM YYYY'),

  dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
    localizer.format(start,  'Do MMMM YYYY') + ' — ' +
    localizer.format(end,  'Do MMMM YYYY')
}

export class BigCustomCalender extends Component {
  constructor(props){
    super(props);
    this.state = {
      view: "month",
      selectedDate: ""
    }
  }

  handleOnNavigate = (date) => {
   // console.log("handleOnNavigate", date);
    this.setState({
      selectedDate: date
    })
    this.props.onNavigate(date);
  }

  handleUpdateView = (view) => {
    this.setState({
      view: view
    })
  }

  onSelecting = (dateTime) =>{
    console.log("dateTime", dateTime)
  }

  onSelectSlot = (data) => {
   // console.log("obj", data);
    this.setState({
      view: "day",
      selectedDate: data.start
    })
    this.props.onNavigate(data.start);
  }

//   dayPropGetter = (data) => {
// console.log("dayPropGetter",data)
// return {className:`day-box`};
//   }

    render(){
        return(
            <div className="big-calender">
              <Calendar
              localizer={localizer}
              events={this.props.data}
              step={5}
              formats={formats} 
              view={this.state.view}
              views={['day','week','month']}
              //min={new Date(2008, 0, 1, 8, 0)} // 8.00 AM
              //max={new Date(2008, 0, 1, 17, 0)} // Max will be 6.00 PM!
              defaultDate={new Date()}
              date={this.state.selectedDate|| undefined}
              startAccessor="start"
              endAccessor="end"
              onSelectSlot={this.onSelectSlot}
              onNavigate={this.handleOnNavigate}
              popup={true}
              selectable={true}
              onSelecting={this.onSelecting}
              onSelectEvent={this.props.onEventSelect}
              timeslots={20}
              // dayPropGetter={this.dayPropGetter}
              // slotPropGetter={this.dayPropGetter}
              // eventPropGetter={this.dayPropGetter}
              onView={this.handleUpdateView}
            />
          </div>
        );
    }



}


export default BigCustomCalender;